/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseNoneTypeMessage } from './genericApiResponseNoneTypeMessage';
import type { GenericApiResponseNoneTypePagination } from './genericApiResponseNoneTypePagination';
import type { GenericApiResponseNoneTypeError } from './genericApiResponseNoneTypeError';

export interface GenericApiResponseNoneType {
  data?: null;
  message?: GenericApiResponseNoneTypeMessage;
  pagination?: GenericApiResponseNoneTypePagination;
  error?: GenericApiResponseNoneTypeError;
  statusCode?: number;
}
